import 'construct-style-sheets-polyfill';
import 'intersection-observer';
import 'plugins';
import './Global.scss';

import {PageManager} from '@mvps-genesis/core';
import AOS from 'aos';
import {bootstrapHawksearch} from 'extensions/hawksearch/pages/global';
import 'extensions/ui-components/x-mini-basket';
import {UncriticalLink} from 'extensions/uncritical-link';
import 'jquery-menu-aim';
import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset.min.js';
import 'lazysizes/plugins/custommedia/ls.custommedia.min.js';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks.min.js';
import 'magnific-popup';

/* eslint-disable max-lines-per-function, sort-keys, no-invalid-this*/

export default class Global extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {
		const self = this;
		window.LC_API = window.LC_API || {};
		self.init();
	}

	init () {
		const self = this;

		self.loadUncriticalLinks();

		self.aos();

		self.toggleGlobalSearch();

		self.backToTop();

		self.jsSlideToggle();

		self.smoothScroll();

		self.continueShopping();

		self.clFormInput();

		self.promoBottomBar();

		self.heroVideoBG();

		self.youtubeVideoTriggers();

		self.sectionComponents();

		self.landingComponents();

		self.miniBasket();

		self.mobileMenu();

		self.globalFooter();

		self.primaryMegaMenu();

		self.floatingPlaceholder();

		self.instagram();

		self.careers();

		self.misc();

		self.carouselSlider();

		self.setGoogleReCaptcha();

		self.initGTM();

		self.initPageBuilder();

		// Main entry for global Hawksearch apps/tracking
		bootstrapHawksearch(this.pageContext);

		self.myRegistry();

		self.googleTranslate();
		self.stickyHeader();

		self.accordions();

		self.footerJS();
	}

	loadUncriticalLinks () {
		const uncriticalLinks = document.querySelectorAll(UncriticalLink.selector);

		if (uncriticalLinks?.length > 0) {
			UncriticalLink.createFromNodeList(uncriticalLinks);
		}
	}

	aos () {
		AOS.init({
			disable: 'mobile'
		});
	}

	async initGTM () {
		const {default: GTM} = await import('extensions/gtm');

		const gtm = new GTM(this.pageContext);
		gtm.init();

		// Listen for Print Events
		window.addEventListener('beforeprint', () => {
			gtm.sendEvent({
				action: 'Click',
				category: 'Print',
				label: document.title,
				noninteractionHit: false
			});
		});

		const footerPhoneNumber = document.querySelector('.js-footer-phone-number');

		if (footerPhoneNumber) {
			footerPhoneNumber.addEventListener('click', () => {
				gtm.sendEvent({
					action: 'Footer - Phone Number',
					category: 'Phone Number Click',
					label: '',
					noninteractionHit: false
				});
			});
		}

		// Track Clicks to the Contact Us - Phone Number
		const contactUsPhoneNumber = document.querySelector('.js-ctus-phone-number');

		if (contactUsPhoneNumber) {
			contactUsPhoneNumber.addEventListener('click', () => {
				gtm.sendEvent({
					action: 'Contact Us - Phone Number',
					category: 'Phone Number Click',
					label: '',
					noninteractionHit: false
				});
			});
		}
	}

	async initPageBuilder () {
		const {default: PageBuilder} = await import('extensions/page-builder');

		new PageBuilder();
	}

	toggleGlobalSearch () {
		// ---- Toggle global search display ---- //
		$('#js-open-global-search, #js-open-global-search--tablet').on('click', function (event) {
			event.preventDefault();
			$(this).toggleClass('bg-gray');
			$('#js-global-search').fadeToggle();
		});
	}

	smoothScroll () {
		$(document).on('click', 'a[href^="\#"].smoothscroll', function (event) {
			event.preventDefault();
			const selector = this.href.substr(this.href.indexOf('#'));
			const	target = $(selector);
			let	offset = 10;
			const	windowHeight = $(window).height();
			if (target.offset().top > windowHeight / 2) {
				offset = $('#js-main-header').outerHeight();
				offset += $('.pre-header').outerHeight();
			}
			window.scrollToDiv(target, offset);
		});
	}

	jsSlideToggle () {
		$('.js-slide-toggle').on('click', function (event) {
			event.preventDefault();
			const $trigger = $(this);
			const	$target = $($trigger.data('target'));
			$target.slideToggle('fast');
		});
	}

	backToTop () {
		// ---- Back to Top Controls ---- //
		const chaser = $('#js-chaser');
		const windowHeight = $(window).height();
		if (chaser) {
			$(window).scroll(function() {
				if ($(window).scrollTop() >= windowHeight / 2) {
					chaser.fadeIn();
				} else {
					chaser.hide();
				}
			});
			chaser.on('click', function() {
				$('html, body').animate({
					scrollTop: '0px'
				}, 800);
			});
		}
	}

	clFormInput () {

		/**
		 * Used for C&L Form Input type of "Number"
		 */
		const formNumbers = document.getElementsByClassName('js-cl-form-number');
		const updateFormNumberValue = function (input, increase_decrease) {
			const currentValue = parseInt(input.value, 10);
			if (isNaN(currentValue)) {
				currentValue = 0;
			}

			if (increase_decrease === 'increase') {
				input.value = currentValue + 1;
			} else if (currentValue > 0) {
				input.value = currentValue - 1;
			}
		};

		for (var i = 0; i < formNumbers.length; i++) {
			const form = formNumbers[i];
			const decrease = form.querySelector('.js-cl-form-number-decrease');
			const increase = form.querySelector('.js-cl-form-number-increase');
			const input = form.querySelector('.js-cl-form-number-input');

			if (!input) {
				continue;
			}

			if (decrease) {
				decrease.addEventListener('click', updateFormNumberValue.bind(null, input, 'decrease'), false);
			}

			if (increase) {
				increase.addEventListener('click', updateFormNumberValue.bind(null, input, 'increase'), false);
			}
		}
	}

	continueShopping () {

		/**
		 * On listed pages, return without execution.
		 * On the BASK, update the "Continue Shopping" link from a cookie.
		 * (On other pages Save the url in the cookie "continue"
		 */
		const page = document.body.id;
		if ('js-SRCH,js-PLST,js-OCST,js-OSEL,js-OUS1,js-OUSM,js-OPAY,js-INVC'.indexOf(page) !== -1) {
			return;
		}

		const cont_link = document.getElementById('continue_shopping');
		const restore = window.readCookie('continue');
		if (cont_link !== null && restore) {
			cont_link.setAttribute('href', restore);
		} else if ('js-PROD,js-SFNT,js-CTGY'.indexOf(page)) {
			window.createCookie('continue', window.location.href.split('?')[0], 4);
		}
	}

	promoBottomBar () {
		const $promoBarWrap = $('.bpromo-bar--wrap');
		const $promoBarOpen = $('.bpromo-bar--open');
		const $promoBarClose = $('.bpromo-bar--close');

		// Only display the banner if they have not seen the banner
		if (window.readCookie('seen_promo') === null) {
			$promoBarWrap.removeClass('bpromo-bar--wrap--hide').addClass('bpromo-bar--wrap--show');
		}

		$promoBarOpen.on('click', function() {
			$promoBarWrap.toggleClass('active');
		});

		$promoBarClose.on('click', function() {
			$promoBarWrap.hide();
			window.createCookie('seen_promo', 'true', 7);
		});
	}

	heroVideoBG () {
		if ($(window).innerWidth() > 1024) {
			if ($('html.no-touch')) {
				$('.hero-video').each(function() {
					const src = $(this).data('src');
					if (src) {
						$(this).find('.hero-video-video').html('<video aria-hidden="true" tabindex="-1" autoplay muted loop><source src="' + src + '" type="video/mp4"></video>');
					}
				});
			}
		}
	}

	youtubeVideoTriggers () {
		$('.youtube-trigger').on('click', function(e) {
			const $url = $(this).attr('href');

			e.preventDefault();
			$.magnificPopup.open({
				items: [
					{
						src: $url,
						type: 'iframe'
					}
				],
				type: 'iframe',
				iframe: {
					markup: '<div class="mfp-iframe-scaler">' +
						'<div class="mfp-close"></div>' +
						'<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
						'</div>',
					patterns: {
						youtube: {
							index: 'youtube.com/',
							id: 'v=',
							src: '//www.youtube.com/embed/%id%?rel=0&controls=0'
						},
						vimeo: {
							index: 'vimeo.com/',
							id: '/',
							src: '//player.vimeo.com/video/%id%?autoplay=1'
						}
					},
					srcAction: 'iframe_src'
				}
			});
		});
	}

	async careers () {
		if ($('.careers-testimonials--row__images').length > 0 || $('.careers-testimonials--row__content').length > 0) {
			const {default: careers} = await import('Extensions/careers');
			careers();
		}
	}

	async sectionComponents () {
		if ($('.section-cmp--carousel').length > 0) {
			const {default: sectionComponents} = await import('extensions/sectionComponents');
			sectionComponents();
		}
	}

	// eslint-disable-next-line
	async landingComponents() {
		const {default: globalLandingComponents} = await import('extensions/global-landing-components');
		globalLandingComponents();
	}

	miniBasket () {
		const triggerElements = document.getElementsByClassName('js-mini-basket-trigger');
		const miniBasket = document.querySelector('x-mini-basket');
		if (!miniBasket) {
			return;
		}

		for (const triggerElement of triggerElements) {
			triggerElement.addEventListener('click', (e) => {
				e.preventDefault();
				miniBasket.open();
			});
		}
	}

	mobileMenu () {

		/* Generate All Categories Section */
		if (window.mvtjs) {
			if (window.mvtjs.mobile__navigation_bar_data) {

				// Define Level 1
				const level_1 = document.createElement('ul');
				level_1.className = 'navigation-set horizontal-drop-down';
				level_1.setAttribute('id', 'js-navigation-set');

				window.mvtjs.mobile__navigation_bar_data.forEach(function (navigationitem, index) {

					const li = document.createElement('li');
					li.className = 'level-1';

					if (navigationitem.hasOwnProperty('items') && navigationitem.items.length) {

						const title = document.createElement('span');
						title.className = 'parent mm-parent';
						title.innerHTML = (navigationitem.url) ? navigationitem.link : '<span>' + navigationitem.link + '</span>';

						const content = document.createElement('ul');
						content.className = 'mm-child';

						// Title
						const navigtionTitleLevel2 = document.createElement('li');
						navigtionTitleLevel2.className = 'level-2 navigation-title';
						navigtionTitleLevel2.innerHTML = '<span>' + navigationitem.name + '</span>';
						content.appendChild(navigtionTitleLevel2);

						if (navigationitem.url) {
							// Shop All Hyperlink
							const navigationShopAllHyperlinkLevel2 = document.createElement('a');
							navigationShopAllHyperlinkLevel2.href = navigationitem.url;
							navigationShopAllHyperlinkLevel2.innerHTML = '<span class="navigation-shop-all-link-text">Shop All</span>';
							navigationShopAllHyperlinkLevel2.target = navigationitem.link_targ;
							navigationShopAllHyperlinkLevel2.className = 'navigation-shop-all-link';

							// Shop All
							const navigationShopAllLevel2 = document.createElement('li');
							navigationShopAllLevel2.className = 'level-2 navigaiton-shop-all';
							navigationShopAllLevel2.innerHTML = '<span>' + navigationShopAllHyperlinkLevel2.outerHTML + '</span>';

							content.appendChild(navigationShopAllLevel2);
						}

						navigationitem.items.forEach(function (navigationitem2, index) {

							if (navigationitem2.hasOwnProperty('items') && navigationitem2.items.length) {

								const li2 = document.createElement('li');
								li2.className = 'level-2';

								const title2 = document.createElement('span');
								title2.className = 'mm-child--title';
								title2.innerHTML = navigationitem2.link;

								const content2 = document.createElement('ul');
								content2.className = 'mm-child-2';

								// Title
								var navigtionTitleLevel3 = document.createElement('li');
								navigtionTitleLevel3.className = 'level-3 navigation-title';
								navigtionTitleLevel3.innerHTML = '<span>' + navigationitem2.name + '</span>';
								content2.appendChild(navigtionTitleLevel3);

								if (navigationitem2.url) {
									// Shop All Hyperlink
									const navigationShopAllHyperlinkLevel3 = document.createElement('a');
									navigationShopAllHyperlinkLevel3.href = navigationitem2.url;
									navigationShopAllHyperlinkLevel3.innerHTML = '<span class="navigation-shop-all-link-text">Shop All</span>';
									navigationShopAllHyperlinkLevel3.target = navigationitem2.link_targ;
									navigationShopAllHyperlinkLevel3.className = 'navigation-shop-all-link';

									// Shop All
									const navigationShopAllLevel3 = document.createElement('li');
									navigationShopAllLevel3.className = 'level-3 navigaiton-shop-all';
									navigationShopAllLevel3.innerHTML = '<span>' + navigationShopAllHyperlinkLevel3.outerHTML + '</span>';

									content2.appendChild(navigationShopAllLevel3);
								}

								navigationitem2.items.forEach(function(navigationitem3, index) {

									if (navigationitem3.name == 'end_group') {
										return false;
									}

									const li3 = document.createElement('li');
									li3.classList.add('level-3');
									if (navigationitem3.name.includes('icon-')) {
										li3.classList.add('mobilemenu-mm-has-icon');
									}
									li3.innerHTML = (navigationitem3.url) ? '<span><a href="' + navigationitem3.url + '" target="' + navigationitem3.link_targ + '">' + navigationitem3.name + '</a></span>' : '<span>' + navigationitem3.link + '</span>';

									content2.appendChild(li3);
								});

								li2.appendChild(title2);
								li2.appendChild(content2);


								const next_trigger = document.createElement('span');
								next_trigger.className = 'next icon-caret--right';

								li2.appendChild(next_trigger);

								// Append to level 2
								content.appendChild(li2);

							} else {

								if (navigationitem2.name == 'end_group') {
									return false;
								}

								const li2 = document.createElement('li');
								li2.className = 'level-2';
								li2.innerHTML = '<span>' + navigationitem2.link + '</span>';

								content.appendChild(li2);

							}
						});

						li.appendChild(title);
						li.appendChild(content);

						const next_trigger = document.createElement('span');
						next_trigger.className = 'next icon-caret--right';

						li.appendChild(next_trigger);

						// Append to Level 1
						level_1.appendChild(li);

					} else {

						/* Standard links */
						li.innerHTML = '<span>' + navigationitem.link + '</span>';

						// Append to Level 1
						level_1.appendChild(li);
					}

				});

				if ('mobile__navigation_bar_data_secondary' in window.mvtjs) {
					Array.prototype.slice.call(window.mvtjs.mobile__navigation_bar_data_secondary).forEach(function(navigationitem, index) {
						const li = document.createElement('li');
						li.className = 'level-1 navigation-secondary';

						if (index === 0) {
							li.classList.add('navigation-secondary-first');
						}

						if (typeof navigationitem.link === 'string' && navigationitem.link.length) {
							li.innerHTML = '<span>' + navigationitem.link + '</span>';
						} else {
							li.innerHTML = '<span>' + navigationitem.name + '</span>';
						}

						level_1.appendChild(li);
					});
				}

				if (typeof window.mvtjs.mobile__navigation_bar_data_footer !== 'undefined') {
					const li = document.createElement('li');
					li.className = 'level-1 navigation-footer';
					li.innerHTML = window.mvtjs.mobile__navigation_bar_data_footer;
					level_1.appendChild(li);
				}

				// Insert into DOM
				$('#js-mobile-navigation').html(level_1);
			}
		}
	}

	async instagram () {
		// INSTAGRAM
		if (document.getElementsByClassName('x-instagram_carousel').length > 0) {

			const {default: customCarousel} = await import('Extensions/custom-carousel');

			customCarousel('.x-instagram_carousel', {
				draggable: true,
				dots: true,
				slidesToShow: 6,
				slidesToScroll: 6,
				arrows: true,
				infinite: false,
				responsive: [
					{
						breakpoint: 959,
						settings: {
							slidesToShow: 4,
							slidesToScroll: 4
						}
					},
					{
						breakpoint: 767,
						settings: {
							arrows: false,
							slidesToScroll: 3,
							slidesToShow: 3
						}
					}
				]
			});
		}
	}

	async carouselSlider () {
		if (document.getElementsByClassName('is-advertisement-slider').length > 0) {

			const {default: carouselAd} = await import('Extensions/custom-carousel');

			carouselAd('.is-advertisement-slider', {
				arrows: true,
				dots: true,
				infinite: true,
				slidesToShow: 5,
				slidesToScroll: 1,
				responsive: [
					{
						breakpoint: 1280,
						settings: {
							arrows: true,
							dots: false,
							slidesToScroll: 1,
							slidesToShow: 3,
							infinite: true
						}
					},
					{
						breakpoint: 900,
						settings: {
							arrows: true,
							dots: false,
							slidesToScroll: 1,
							slidesToShow: 2,
							infinite: true
						}
					},
					{
						breakpoint: 650,
						settings: {
							arrows: false,
							dots: false,
							slidesToScroll: 1,
							slidesToShow: 2,
							infinite: true,
							centerMode: true,
							centerPadding: '60px'
						}
					}
				]
			});
		}
	}

	async setGoogleReCaptcha () {
		const elements = document.querySelectorAll('.g-recaptcha');

		if (elements.length === 0) {
			return;
		}

		const {default: GoogleRecaptchaElem} = await import('Extensions/google-recaptcha');

		elements.forEach(function (element) {
			new GoogleRecaptchaElem().get(element.parentElement);
		});
	}

	misc () {

		var self = this;
		// ---- Create the "main" element for older versions of IE ---- //
		document.createElement('main');

		$('.js-hide').hide();
		$('.js-show').show();
		$('.js-remove').remove();
		$('select, :text, textarea').not('.input').addClass('input');

		/**
		 * SRCH & CTGY
		 */
		window.showHideListingFacets = function () {
			$('body').toggleClass('no-filters').toggleClass('show-filters');
			$('html').toggleClass('html-show-filters');
			if ($('body').hasClass('show-filters')) {
				MMFacet_RangeSlider_Initialize();
				$('input[name="Facet_Toggle"]').val('open');
				window.createCookie('toggleFacets', 'open', 1000);
			} else {
				$('input[name="Facet_Toggle"]').val('closed');
				window.createCookie('toggleFacets', 'closed', 1000);
			}
		};

	}

	globalFooter () {
		// ---- Mobile Footer Links Control ---- //
		const mobileFooterToggles = function (h5) {
			if ($(window).width() <= 768) {
				if ($(h5).parent().find('.mobile-toggle').is(':visible')) {
					$(h5).find('span').attr('data-icon', 'L');
				} else {
					$(h5).find('span').attr('data-icon', 'K');
				}
				$(h5).parent().find('.mobile-toggle').slideToggle();
			}
		};

		$('footer h5').on('click', function(e) {
			mobileFooterToggles($(this));
		});

		if ($(window).innerWidth() < 959) {
			// Add tabindex (focusable)
			$('.mobile-tabs-toggle').attr({
				'aria-expanded': false,
				role: 'button',
				tabindex: 0
			});

			$('.mobile-tabs > div').find('.main-footer--content').attr('aria-hidden', true);

			$('.mobile-tabs-toggle').on('click', function () {
				const $tabItem = $(this).parent('div').find('.main-footer--content');

				$('.mobile-tabs-toggle').attr('aria-expanded', false);
				$('.mobile-tabs > div').find('.main-footer--content').attr('aria-hidden', true);

				if ($tabItem.is(':visible')) {
					$(this).parent('div').toggleClass('active').find('.main-footer--content').slideToggle().toggleClass('show');
					$tabItem.attr('aria-hidden', true);
					$(this).attr('aria-expanded', false);
				} else {
					$tabItem.attr('aria-hidden', false);
					$(this).attr('aria-expanded', true);
				}

				if ($tabItem.is(':visible')) {
					return false;
				}

				$('.mobile-tabs > div.active').find('.main-footer--content').slideToggle().toggleClass('show');
				$('.mobile-tabs > div.active').removeClass('active');
				$(this).parent('div').toggleClass('active');
				$(this).parent('div').find('.main-footer--content').slideToggle().toggleClass('show');
			});
		}
	}

	primaryMegaMenu () {
		let timeout_id = 0;
		$('#js-mega-menu .horizontal-mega-menu').menuAim({
			activate: function (row) {
				timeout_id = setTimeout(function () {
					$(row).addClass('active').find('.level-1-a').attr('aria-expanded', true);
					$(row).find('.mm-submenu-container').attr('aria-hidden', false);
				}, 275);
			},
			deactivate: function (row) {
				clearTimeout(timeout_id);
				$(row).removeClass('active').find('.level-1-a').attr('aria-expanded', false);
				$(row).find('.mm-submenu-container').attr('aria-hidden', true);
			},
			exitMenu: function (menu) {
				clearTimeout(timeout_id);
				$(menu).find('.level-1.active .mm-submenu-container').attr('aria-hidden', true);
				$(menu).find('.level-1.active').removeClass('active').find('.level-1-a').attr('aria-expanded', false);
			},
			submenuDirection: 'below'
		});
	}


	floatingPlaceholder () {
		const updateText = function (event) {
			const $input = $(this);

			setTimeout(function () {
				if ($input.val() !== '' || $input.is(':focus') || $input.prop('tagName') === 'SELECT') {
					$input.parent().addClass('floating-placeholder-float');
				} else {
					$input.parent().removeClass('floating-placeholder-float');
				}
			}, 1);
		};
		$('.floating-placeholder .input, .floating-placeholder input').each(updateText);
		$('.floating-placeholder .input, .floating-placeholder input, .floating-placeholder select').on('input keyup change blur', updateText);
	}

	// Checks for and sets the myRegistryID session cookie if the mrRID parameter is present
	myRegistry () {
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const mrRID = urlParams.get('mrRID');

		if (mrRID) {

			/*
			 * If myRegistryID is being passed
			 * then, set the cookie.
			 */
			window.createCookie('mrRID', encodeURIComponent(mrRID));
		}
	}

	googleTranslate () {
		const googleElem = document.getElementById('google_translate_element');
		if (!googleElem) {
			return;
		}

		const observer = new MutationObserver(function (mutationsList, ob) {
			for (const mutation of mutationsList) {
				const anchors = mutation.target.querySelectorAll('a');
				if (anchors.length > 0) {
					for (const anchor of anchors) {
						anchor.addEventListener('click', (e) => e.preventDefault());
					}
					ob.disconnect();
				}
			}
		});

		observer.observe(googleElem, {
			childList: true,
			subtree: true
		});
	}

	stickyHeader () {
		const el = document.getElementById('js-main-header');
		if (!el) {
			return;
		}

		const observer = new IntersectionObserver(
			([e]) => e.target.classList.toggle('is-pinned', e.intersectionRatio < 1),
			{threshold: [1]}
		);

		observer.observe(el);
	}

	accordions () {
		const accordions = document.getElementsByClassName('accordion');
		if (!accordions.length) {
			return;
		}

		for (const accordion of accordions) {
			if (accordion.querySelector('.x-accordion')) {
				continue;
			}

			const newAccordion = document.createElement('div');

			for (const child of accordion.children) {
				const headingElement = child.children[0];
				const textElement = child.children[1];

				if (!headingElement || !textElement) {
					continue;
				}

				textElement.classList.add('x-accordion__copy');

				const li = document.createElement('li');
				li.classList.add('x-accordion');

				li.innerHTML = `
					<details class="x-accordion--inner">
						<summary class="x-accordion__label-container">
							<span class="x-accordion__label-inner">
								<span class="x-accordion__label">${headingElement.outerHTML}</span><span class="x-accordion__toggle" aria-hidden="true"></span>
							</span>
						</summary>
						${textElement.outerHTML}
					</details>
				`;

				newAccordion.appendChild(li);
			}

			accordion.innerHTML = newAccordion.innerHTML;

		}
	}

	footerJS () {
		if ($('#js-navigation-set').length > 0) {
			$('li.level-2 span a').each(function () {
				if ($(this).text() === 'Sale') {
					$(this).parent().addClass('sale');
				}
			});
		}

		const addOnKeyUp = (classname) => {
			var elements = document.getElementsByClassName(classname);
			for (var i = 0; i < elements.length; i++) {
				elements[i].setAttribute('onkeyup', elements[i].getAttribute('onclick'));
			}
		};

		addOnKeyUp('apple-pay-button');

		const clearFacetAria = () => {
			let facets = document.querySelectorAll('.facet-options--toggle');
			for (let i = 0; i < facets.length; i++) {
				facets[i].setAttribute('aria-expanded', 'false');
			}
		};

		// Force tab index on item that loads dynamically after page loads
		const forceSelectorTab = () => {
			let selectors = document.querySelectorAll('.facets-options--group-item-ui, .facets-tree a ');
			for (let i = 0; i < selectors.length; i++) {
				selectors[i].setAttribute('tabindex', 0);
				selectors[i].setAttribute('role', 'button');
				selectors[i].setAttribute('aria-describedby', selectors[i].parentElement.getAttribute('for'));
				selectors[i].addEventListener('keydown', (e) => {
					if (e.key === 'Enter') {
						e.target.click();
						forceSelectorTab();
					}
				});
			}
		};

		const forceFacetTab = () => {
			forceSelectorTab();
			document.querySelector('.facets-tree-heading-text').setAttribute('tabindex', 0);
			let facets = document.querySelectorAll('.facet-options--toggle');
			for (let i = 0; i < facets.length; i++) {
				facets[i].setAttribute('tabindex', 0);
				facets[i].setAttribute('role', 'button');
				if (facets[i].classList.contains('active')) {
					facets[i].setAttribute('aria-expanded', 'true');
				} else {
					facets[i].setAttribute('aria-expanded', 'false');
				}

				facets[i].addEventListener('keydown', (e) => {
					if (e.key === 'Enter') {
						e.target.click();
						clearFacetAria();
						if (e.target.classList.contains('active')) {
							e.target.setAttribute('aria-expanded', 'true');
						}
					}
				});
			}
		};

		let MaxTime = 30000;
		let totalTime = 0;
		const intervalSearch = () => {
			if (document.getElementsByClassName('facet-options--toggle').length > 0) {
				forceFacetTab();
			} else if (totalTime < MaxTime) {
				setTimeout(intervalSearch, 20);
				totalTime += 20;
			}
		};
		intervalSearch();

		totalTime = 0;
		const intervalSearch2 = () => {
			if (document.querySelectorAll('.klaviyo-form-version-cid_3 img').length > 0) {
				document.querySelector('.klaviyo-form-version-cid_3 img').setAttribute('alt', '');
			} else if (totalTime < MaxTime) {
				setTimeout(intervalSearch2, 20);
				totalTime += 20;
			}
		};
		intervalSearch2();

		const keyToClick = () => {
			let newfocusableElems = document.querySelectorAll('a:not(.level-1-a), [tabindex="0"], button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
			for (let i = 0; i < newfocusableElems.length; i++) {
				newfocusableElems[i].addEventListener('keydown', (e) => {
					if (e.key === 'Enter') {
						e.target.click();
					}
				});
			}
		};

		keyToClick();

		// Get the primary nav working with keyboard accessibility features
		$('li .level-1-a').keydown(function (e) {
			if (e.key === 'Enter' && e.currentTarget.parentNode.classList.contains('active')) {
				e.currentTarget.parentNode.classList.remove('active');
				e.currentTarget.setAttribute('aria-expanded', false);
				e.stopPropagation();
				e.preventDefault();
			}
		});

		// Adds open in new window to any link that opens in a new window
		const addHiddenTitleToNewWindowLink = () => {
			var elements = document.querySelectorAll("[target='_blank']");
			for (var i = 0; i < elements.length; i++) {
				var title = document.createElement('span');
				var textnode = document.createTextNode(' Open in new window');
				title.classList.add('sr-only');
				title.appendChild(textnode);
				elements[i].appendChild(title);
			}
		};
		addHiddenTitleToNewWindowLink();

		// Register IntersectionObserver
		const io = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				entry.target.removeAttribute('tabindex');
			});
		});

		setTimeout(function () {
			// Declares what to observe, and observes its properties.
			const boxElList = document.querySelectorAll('.x-carousel_item');
			boxElList.forEach((el) => {
				io.observe(el, {attributes: true});
			});

			const igCarousels = document.querySelectorAll('.x-instagram_carousel-item');
			igCarousels.forEach((el) => {
				io.observe(el, {attributes: true});
			});
		}, 5000);

		const carousels = document.querySelectorAll('.x-carousel-wrapper');
		if (carousels) {
			carousels.forEach((x, i) => {
				const skipLink = document.createElement('a');
				skipLink.classList.add('sr-only');
				skipLink.href = window.mivaJS.Self_Auto + '#afterCarousel__' + i;
				skipLink.innerHTML = 'Skip carousel';

				x.prepend(skipLink);

				x.innerHTML += '<div class="sr-only" id="afterCarousel__' + i + '"></div>';
			});
		}


	}

}
